import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import {
  addBusinessDays,
  addDays,
  addMonths,
  addWeeks,
  isWednesday,
  format,
} from "date-fns";
import {
  validateSubBroker,
  getAssetClasses,
  getOtherSchemes,
  swpOptions,
  CalcSIPEnddt,
  setStpDetails,
  saveTransactionDetails,
  getMinimumAmount,
} from "../../../store/actions";
import { REGULAR, PURCHASE, STP } from "../../../store/types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { NEW_TRANSACTION_URL } from ".";
import { BajajFund } from "../nav";

class Stp extends Component {
  constructor(props) {
    super(props);
    // const { fundList } = this.props;
    const { stpDetails } = this.props;
    // const funds = fundList.reduce((prev, curr) => {
    //   const findIndex =
    //     prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
    //   if (!findIndex) {
    //     return [...prev, { Fund: curr.Fund, FundDesc: curr.FundDesc }];
    //   }
    //   return prev;
    // }, []);

    this.state = {
      // funds,
      fund: { value: { value: "189" } },
      folios: [],
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      minAmount:{value:""},
      radioValue: { value: "no" },
      arnCode: { value: this.props.token },
      subArnCode: { value: "" },
      euinNo: { value: "" },
      subBrokerCode: { value: "" },
      categories: [],
      category: { value: "" },
      switchInSchemes: [],
      switchInScheme: { value: "" },
      sipCycle: [],
      sipDay: { value: "" },
      transfers: { value: "" },
      sipEndDate: { value: "" },
      sipStartDate: { value: "" },
      stpDates: [],
      swpOptions: [],
      swpOption: { value: "" },
      amount: { value: "" },
      swpFrequency: { value: "" },
      minimumInstallments: "",
      multiples: "",
      ...stpDetails,
    };
  }

  handleFundChange = (value) => {
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        folio: { value: "" },
        subArnCode: { value: "" },
        euinNo: { value: "" },
        subBrokerCode: { value: "" },
        categories: [],
        category: { value: "" },
        switchInSchemes: [],
        switchInScheme: { value: "" },
        sipCycle: [],
        sipDay: { value: "" },
        transfers: { value: "" },
        sipEndDate: { value: "" },
        sipStartDate: { value: "" },
        swpOptions: [],
        swpOption: { value: "" },
        amount: { value: "" },
        swpFrequency: { value: "" },
        schemes: [],
        scheme: { value: "" },
      });
      return;
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const fund = value.value;
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        folio: { value: "" },
        scheme: { value: "" },
        schemes: [],
        subArnCode: { value: "" },
        euinNo: { value: "" },
        subBrokerCode: { value: "" },
        categories: [],
        category: { value: "" },
        switchInSchemes: [],
        switchInScheme: { value: "" },
        sipCycle: [],
        sipDay: { value: "" },
        transfers: { value: "" },
        sipEndDate: { value: "" },
        sipStartDate: { value: "" },
        swpOptions: [],
        swpOption: { value: "" },
        amount: { value: "" },
        swpFrequency: { value: "" },
      });
      if (!!fund) {
        this.validateBrokerCode(fund)();
      }
    }
  };

  async componentDidMount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });

    const { transactionDetails } = this.props;
    if (Object.keys(transactionDetails).length > 0) {
      this.setState(transactionDetails);
      return;
    }
    this.getFolios();
  }
  getFolios = () => {
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (curr.Fund.trim() === "189") {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);

    this.setState({
      fund: { value: { value: "189" } },
      folios: Array.from(new Set(folios)),
      folio: { value: "" },
      scheme: { value: "" },
      schemes: [],
      subArnCode: { value: "" },
      euinNo: { value: "" },
      subBrokerCode: { value: "" },
      categories: [],
      category: { value: "" },
      switchInSchemes: [],
      switchInScheme: { value: "" },
      sipCycle: [],
      sipDay: { value: "" },
      transfers: { value: "" },
      sipEndDate: { value: "" },
      sipStartDate: { value: "" },
      swpOptions: [],
      swpOption: { value: "" },
      amount: { value: "" },
      swpFrequency: { value: "" },
    });
    this.validateBrokerCode("189")();
  };

  validateBrokerCode = (fund) => async () => {
    const { subArnCode, arnCode } = this.state;
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }
    const params = {
      Fund: "189",
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    const response = await this.props.validateSubBroker(params);
    if (!!response && !!response.DtData && response.DtData.length > 0) {
      const getLength = response.DtData.length === 1;
      let value = {
        value: response.DtData[0].abm_agent,
        label: response.DtData[0].abm_agent,
      };
      if (!!getLength) {
        this.setState({
          euinNo: { value },
        });
      }
    } else if (!response) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `Please enter a valid Sub ARN Code`,
        },
      });
    }
  };

  handleFolioChange = (value) => {
    if (!value) {
      this.setState({
        folio: { value: "" },
        schemes: [],
        scheme: { value: "" },
        subArnCode: { value: "" },
        euinNo: { value: "" },
        subBrokerCode: { value: "" },
        categories: [],
        category: { value: "" },
        switchInSchemes: [],
        switchInScheme: { value: "" },
        sipCycle: [],
        sipDay: { value: "" },
        transfers: { value: "" },
        sipEndDate: { value: "" },
        sipStartDate: { value: "" },
        swpOptions: [],
        swpOption: { value: "" },
        amount: { value: "" },
        swpFrequency: { value: "" },
      });
      return;
    } else if (value.value === this.state.folio.value.value) {
      return;
    } else {
      this.getAssetClasses(value.value);
      const schemes = this.schemes(value.value);

      this.setState({
        folio: { value },
        schemes,
        scheme: { value: "" },
      });
    }
  };

  getAssetClasses = async (value) => {
    const params = {
      Fund: this.state.fund.value.value,
      Folio: value,
    };
    const assetClasses = await this.props.getAssetClasses(params);
    if (assetClasses) {
      this.setState({
        categories: assetClasses.DtData,
      });
    }
  };

  schemes = (value) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (curr.Fund === this.state.fund.value.value && curr.Acno === value) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };
  handleSchemeChange = (value) => {
    if (!value) {
      this.setState({
        scheme: { value: "" },
        category: { value: "" },
        switchInSchemes: [],
        switchInScheme: { value: "" },
        sipCycle: [],
        sipDay: { value: "" },
        transfers: { value: "" },
        sipEndDate: { value: "" },
        sipStartDate: { value: "" },
        swpOptions: [],
        swpOption: { value: "" },
        amount: { value: "" },
        swpFrequency: { value: "" },
      });
      return;
    } else if (value.value === this.state.scheme.value.value) {
      return;
    } else {
      if (!value.value.BalUnits) {
        this.setState({
          folio: {
            value: "",
            isError: "true",
            errorMessage: "STP in Zero balance folios is not accepted",
          },
          scheme: { value: "" },
        });
      } else {
        this.setState({
          scheme: { value },
          category: { value: "" },
          switchInSchemes: [],
          switchInScheme: { value: "" },
          sipCycle: [],
          sipDay: { value: "" },
          transfers: { value: "" },
          sipEndDate: { value: "" },
          sipStartDate: { value: "" },
          swpOptions: [],
          swpOption: { value: "" },
          amount: { value: "" },
          swpFrequency: { value: "" },
        });
      }
    }
  };
  handleCategoryChange = (event) => {
    if (event.target.value) {
      this.getOtherSchemes(event.target.value);
      this.setState({
        category: { value: event.target.value },
        switchInScheme: { value: "" },
        sipCycle: [],
        sipDay: { value: "" },
        transfers: { value: "" },
        sipEndDate: { value: "" },
        sipStartDate: { value: "" },
        swpOptions: [],
        swpOption: { value: "" },
      });
    } else {
      this.setState({
        category: { value: "" },
        switchInScheme: { value: "" },
      });
    }
  };
  getOtherSchemes = async (value) => {
    const params = {
      schtype: REGULAR,
      category: value,
      acno: this.state.folio.value.value,
      fundCode: this.state.fund.value.value,
      trantype: "T",
    };
    const otherSchemes = await this.props.getOtherSchemes(params);

    if (otherSchemes) {
      this.setState({
        switchInSchemes: otherSchemes.DtData,
      });
    }
  };
  handleSwitchInScheme = async (value) => {
    if (!value) {
      this.setState({
        switchInScheme: { value: "" },
        // sipCycle: [],
        sipDay: { value: "" },
        transfers: { value: "" },
        sipEndDate: { value: "" },
        sipStartDate: { value: "" },
        swpOptions: [],
        swpOption: { value: "" },
      });
      return;
    } else if (value.value === this.state.switchInScheme.value.value) {
      return;
    } else {
      if (!!value) {
        if (
          `${value.value.fm_scheme}~${value.value.fm_plan}~${value.value.fm_option}` ===
          `${this.state.scheme.value.value.Sch}~${this.state.scheme.value.value.Pln}~${this.state.scheme.value.value.Opt}`
        ) {
          this.setState({
            switchInScheme: {
              value: "",
              isError: true,
              errorMessage:
                "Transfer from Scheme and Transfer to Scheme should not be same",
            },
          });
        } else {
          const params = {
            opt: "SF",
            fund: this.state.fund.value.value,
            astscheme: "",
          };
          const sipCycleResponse = await this.props.swpOptions(params);
          const sipCycleResponseOptions = !!sipCycleResponse
            ? sipCycleResponse.Dtinformation
            : "";
          this.setState({
            switchInScheme: { value },
            stpDates: sipCycleResponseOptions,
            multiples: value.multiples,
          });
        }
      }
    }
  };
  changeValue = (label) => (event) => {
    if (
      label === "subArnCode" ||
      (label === "subBrokerCode" && event.target.value.length <= 20)
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "radioValue" && event.target.value === "no") {
      if (!this.state.euinNo.value) {
        this.setState({
          radioValue: { value: event.target.value },
        });
      } else {
        this.setState({
          [label]: { value: event.target.value },
          euinNo: { value: "" },
        });
      }
    } else if (label === "radioValue" && event.target.value === "yes") {
        this.setState({
          [label]: { value: event.target.value },
          euinNo: { value: "" },
        });
    }else if (
      label !== "subArnCode" &&
      label !== "subBrokerCode" &&
      label === "radioValue" &&
      event.target.value !== "no"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  async handleSwpDay(event) {
    const day = event.target.value;
    const frequency = this.state.swpFrequency.value;
    const transfers = this.state.transfers.value;
    const x = parseFloat(this.state.transfers.value.replace(/,/g, ""));
    if (
      this.state.transfers.value !== "" &&
      (x > parseFloat(this.state.minimumInstallments) ||
        x === parseFloat(this.state.minimumInstallments))
    ) {
      const params = {
        Fund: this.state.fund.value.value,
        StartDate: day,
        installments: this.state.transfers.value,
        Frequency: this.state.swpFrequency.value,
        trtype: "STP",
        sch: this.state.scheme.value.value.Sch,
      };
      if (frequency === "Weekly") {
        const { startDate, endDate } = calculateStpDates(transfers, day);
        const reformSIPEndDT = endDate.value.split("/");
        if (parseFloat(reformSIPEndDT[2]) >= 2099) {
          this.setState({
            sipDay: { value: "" },
            sipStartDate: { value: "" },
            sipEndDate: { value: "" },
            transfers: {
              value: "",
              isError: true,
              errorMessage:
                "Your SIP installments are going beyond 2099, select lesser number of installments.",
            },
          });
          return;
        }
        this.setState({
          sipDay: { value: day },
          sipStartDate: startDate,
          sipEndDate: endDate,
        });
        return;
      }

      const response = await this.props.CalcSIPEnddt(params);
      const sipStartDateResponse = response.DtData[0].SIP_StartDate;
      const sipEndDateResponse = response.DtData[0].SIP_EndDate;
      if (!!sipEndDateResponse) {
        const reformSIPEndDT = sipEndDateResponse.split("/");
        if (parseFloat(reformSIPEndDT[2]) >= 2099) {
          this.setState({
            sipDay: { value: "" },
            sipStartDate: { value: "" },
            sipEndDate: { value: "" },
            transfers: {
              value: "",
              isError: true,
              errorMessage:
                "Your SIP installments are going beyond 2099, select lesser number of installments.",
            },
          });
        } else if (parseFloat(reformSIPEndDT[2]) < 2099) {
          this.setState({
            sipDay: { value: day },
            sipStartDate: { value: sipStartDateResponse },
            sipEndDate: { value: sipEndDateResponse },
          });
        }
      }
    }
  }
  handleChangeTransfers = async (event) => {
    const transferValue = event.target.value;
    const params = {
      fund: "189",
      opt: "SWPW",
      customfund: "189",
    };
    if (!this.state.swpOption.value && event.target.value.length <= 3) {
      const response = await this.props.swpOptions(params);
      const swpOptionsResponse = response.Dtinformation;
      if (!!transferValue && parseFloat(transferValue) <= 999) {
        this.setState({
          transfers: { value: transferValue },
          swpOptions: swpOptionsResponse,
          sipDay: { value: "" },
          sipEndDate: { value: "" },
          sipStartDate: { value: "" },
          swpOption: { value: swpOptionsResponse[0] },
        });
      } else if (!transferValue) {
        this.setState({
          transfers: {
            value: "",
            isError: true,
            errorMessage: !!transferValue
              ? "no of transfers value should not be more than 999"
              : "transfers value is mandatory*",
          },
          swpOptions: swpOptionsResponse,
          sipDay: { value: "" },
          sipEndDate: { value: "" },
          sipStartDate: { value: "" },
          swpOption: { value: "" },
        });
      }
    } else if (event.target.value.length <= 3) {
      this.setState({
        transfers: { value: transferValue },
        sipEndDate: { value: "" },
        sipDay: { value: "" },
        sipStartDate: { value: "" },
      });
    }
  };
  handleSwpOptionChange = (event) => {
    const swpOption = event.target.value;

    this.setState({
      swpOption: { value: swpOption },
      amount: { value: "" },
    });
  };
  handleChangeTransferAmount = (event) => {
    const transferAmount = event.target.value;
    if (event.target.value.length <= 10) {
      this.setState({
        amount: { value: transferAmount.replace(/^0+/, "") },
      });
    }
  };
  changeEuin = (value) => {
    this.setState({
      euinNo: { value },
    });
  };

  submit = () => {
    let currValue;
    let amountValue;
    const {
      amount,
      transfers,
      sipEndDate,
      sipStartDate,
      funds,
      folios,
      schemes,
      categories,
      switchInSchemes,
      sipCycle,
      subBrokerCode,
      subArnCode,
      radioValue,
      euinNo,
      arnCode,
      swpOptions,
      swpFrequency,
      stpDates,
      minimumInstallments,
      multiples,
      ...others
    } = this.state;
    if (!!this.state.scheme.value) {
      currValue = parseInt(
        this.state.scheme.value.value.CurValue.replace(/,/g, "")
      );
    }

    if (!!this.state.amount) {
      amountValue = parseFloat(this.state.amount.value.replace(/,/g, ""));
    }
    if (this.state.transfers.value === "") {
      this.setState({
        transfers: {
          value: "",
          isError: true,
          errorMessage: "(Please enter the no of transfers value)",
        },
      });
    }

    if (
      this.state.radioValue.value === "no" ||
      this.state.euinNo.value === ""
    ) {
      this.setState({
        euinNo: {
          value: "",
          isError: true,
          errorMessage: "EUIN No is mandatory",
        },
      });
    }
    // if (
    //   !!this.state.scheme.value &&
    //   !!this.state.amount.value &&
    //   parseInt(this.state.amount.value) > currValue
    // ) {
    //   this.setState({
    //     amount: {
    //       value: "",
    //       isError: true,
    //       errorMessage: `(Transfer amount is more than the current Value)`,
    //     },
    //   });
    //   return;
    // }
    // if (
    //   this.state.transfers.value * Number(this.state.amount.value) >
    //   currValue
    // ) {
    //   this.setState({
    //     amount: {
    //       value: "",
    //       isError: true,
    //       errorMessage: "Installmentwise enter the greater than current value",
    //     },
    //   });
    //   return;
    // }

    const minAmount = 1000;
    const arn = this.state.arnCode.value.split("-");
    const keys = Object.keys(others);

    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "sipDay"
                  ? "STP date"
                  : key === "swpOption"
                  ? "STP option"
                  : key === "folio"
                  ? "Folio"
                  : key === "scheme"
                  ? "Transfer from Scheme"
                  : key === "category"
                  ? "Category"
                  : key === "switchInScheme"
                  ? "Transfer to Scheme"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "category": {
          this.categoryField.focus();
          break;
        }
        case "switchInScheme": {
          this.switchInSchemeField.focus();
          break;
        }
        case "sipDay": {
          this.swpDateField.focus();
          break;
        }
        case "swpOption": {
          this.swpField.focus();
          break;
        }
      }
    } else if (
      !!this.state.subArnCode.value &&
      arn[1] === this.state.subArnCode.value
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should not match `,
        },
      });
    } else if (
      (amountValue < this.state.minAmount.value || this.state.amount.value === "") &&
      this.state.swpOption.value.Description === "Fixed"
    ) {
      if (this.state.amount.value === "") {
        this.setState({
          amount: {
            ...others["amount"],
            isError: true,
            errorMessage: `Transfer amount value is mandatory`,
          },
        });
      } else if (amountValue < this.state.minAmount.value) {
        this.setState({
          amount: {
            ...others["amount"],
            isError: true,
            errorMessage: `Minimum amount is 1000 (₹) for Monthly STP frequency`,
          },
        });
      }

      // else if (amountValue > currValue) {
      //   this.setState({
      //     amount: {
      //       ...others["amount"],
      //       isError: true,
      //       errorMessage: `(Transfer amount is more than the current Value)`
      //     }
      //   });
      // }
    } else if (
      +this.state.amount.value % +this.state.multiples !== 0 &&
      this.state.swpOption.value.Description === "Fixed"
    ) {
      this.setState({
        amount: {
          ...others["amount"],
          isError: true,
          errorMessage: `Transfer amount should be multiple of ${this.state.multiples}`,
        },
      });
      return;
    } else if (
      this.state.radioValue.value === "no" &&
      !this.state.euinNo.value
    ) {
      this.euinField.focus();
      this.setState({
        euinNo: {
          value: "",
          isError: true,
          errorMessage: "Please select EUIN No",
        },
      });
    } else if (
      this.state.transfers.value === "" ||
      parseFloat(this.state.transfers.value) <
        parseFloat(this.state.minimumInstallments)
    ) {
      this.setState({
        transfers: {
          value: "",
          isError: true,
          errorMessage: "Please check the no of transfers value",
        },
      });
    } else if (!this.state.swpOption.value) {
      this.setState({
        swpOption: {
          value: "",
          isError: true,
          errorMessage: "STP option is mandatory",
        },
      });
    } else {
      const {
        scheme,
        amount,
        transfers,
        sipEndDate,
        swpOption,
        sipStartDate,
        sipDay,
        euinNo,
        switchInScheme,
        stpDates,
        ...stpDetails
      } = this.state;

      this.props.setStpDetails(this.state);
      this.props.saveTransactionDetails(this.state);
      this.props.history.push({
        pathname: NEW_TRANSACTION_URL + "/stp/digital/transact/confirm",
        state: {
          title: "STP Payment Summary",
          type: STP,
          Folio: { value: this.state.scheme.value.value.Acno },
          scheme: { Fund: "189" },
          ...stpDetails,
        },
      });
    }
  };

  showError = (label) => () => {
    let amountValue, currValue;
    const {
      [label]: { value },
    } = this.state;
    if (!!this.state.amount.value) {
      amountValue = parseFloat(this.state.amount.value.replace(/,/g, ""));
    }
    if (!!this.state.scheme.value) {
      currValue = parseFloat(
        this.state.scheme.value.value.CurValue.replace(/,/g, "")
      );
    }
    // const minAmount = 1000;

    if (label === "transfers") {
      this.setState({
        [label]: {
          value,
          isError:
            parseFloat(this.state.transfers.value) <
              parseFloat(this.state.minimumInstallments) ||
            this.state.transfers.value === ""
              ? true
              : !value,
          errorMessage:
            parseFloat(this.state.transfers.value) <
              parseFloat(this.state.minimumInstallments) ||
            this.state.transfers.value === ""
              ? `No of withDrawals should be minimum ${this.state.minimumInstallments}`
              : "",
        },
      });
    } else if (label === "amount") {
      this.setState({
        [label]: {
          value,
          isError:
          amountValue < this.state.minAmount.value &&
          this.state.swpOption.value.Description === "Fixed"
              ? true
              : !value,
          errorMessage:
          amountValue < this.state.minAmount.value &&
          this.state.swpOption.value.Description === "Fixed"
          ? `Amount should be ${this.state.minAmount.value}(INR)`
          : "",
        },
      });
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  handleChangeStpFrequency = async (event) => {
    if (event.target.value === this.state.swpFrequency.value) {
      return;
    } else {
      if (!!event.target.value) {
        const minParams = {
          Fund: this.state.fund.value.value,
          Scheme: this.state.scheme.value.value.Sch,
          Trtype: "STP",
          Frequency: event.target.value,
        };
        const response = await this.props.getMinimumAmount(minParams);
        if (response) {
          const { DtData } = response;
          this.setState({
            minAmount: {
              value: DtData[0].minamt
            },
          })
        }
      }

      const transfer = this.state.stpDates.find(
        (ele) => ele.FrequencyID === event.target.value
      );
      const params = {
        opt: "STPD",
        fund: this.state.fund.value.value,
        astscheme: event.target.value,
      };
      const sipCycleResponse = await this.props.swpOptions(params);
      const sipCycleResponseOptions = !!sipCycleResponse
        ? sipCycleResponse.Dtinformation
        : "";

      this.setState({
        swpFrequency: { value: event.target.value },
        minimumInstallments: transfer.Minimum_Instalment,
        transfers: { value: "" },
        sipCycle: sipCycleResponseOptions,
      });
    }
  };

  render() {
    const {
      funds,
      fund,
      folio,
      folios,
      scheme,
      schemes,
      categories,
      category,
      arnCode,
      subArnCode,
      subBrokerCode,
      switchInScheme,
      switchInSchemes,
      euinNo,
      radioValue,
      sipCycle,
      sipDay,
      transfers,
      sipStartDate,
      sipEndDate,
      swpOptions,
      swpOption,
      stpDates,
      amount,
    } = this.state;
    // let e;
    // e = parseFloat(this.state.transfers.value.replace(/,/g, ""));
    const { euinList } = this.props;
    return (
      <div className="transaction-details">
        <div className="title"> STP Plan</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            type="number"
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            disabled={!fund.value}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">
            Transfer From Scheme
          </div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              value: item,
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            disabled={!folio.value}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>
        <div className="redemption-details">
          <div className="keys">
            <div>Balance Units </div>
            <div>Current Value</div>
          </div>
          <div className="values">
            <div>{!!scheme.value.value ? scheme.value.value.BalUnits : ""}</div>
            <div>{!!scheme.value.value ? scheme.value.value.CurValue : ""}</div>
          </div>
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="Category"
            placeholder="Switch in Category"
            handleChange={this.handleCategoryChange}
            value={category.value}
            inputRef={(ele) => (this.categoryField = ele)}
            isError={category.isError}
            disabled={!scheme.value}
            errorMessage={category.errorMessage}
          >
            {categories.map((item, index) => (
              <MenuItem value={item.CatValue} key={index}>
                {item.CatValue}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">
            Transfer To Scheme
          </div>
          <IntegrationReactSelect
            suggestions={switchInSchemes.map((item) => ({
              label: item.fm_schdesc,
              value: item,
              multiples: item.multiples,
            }))}
            label="Fund"
            handleChange={this.handleSwitchInScheme}
            value={switchInScheme.value}
            placeholder="Select Fund"
            inputRef={(ele) => (this.switchInSchemeField = ele)}
            isError={switchInScheme.isError}
            errorMessage={switchInScheme.errorMessage}
          />
        </div>

        <div className="input-margin">
          <Input
            name="ARN Code"
            value={arnCode.value.split("-")[1]}
            disabled={true}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Sub ARN Code"
            value={subArnCode.value}
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            disabled={!fund.value}
            type="number"
            isShowError={subArnCode.isError}
            errorMessage={subArnCode.errorMessage}
            onBlur={
              !!fund.value ? this.validateBrokerCode(fund.value.value.Fund) : ""
            }
            onChange={this.changeValue("subArnCode")}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Sub Broker Code"
            value={subBrokerCode.value}
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            type="number"
            onChange={this.changeValue("subBrokerCode")}
          />
        </div>
        <div className="input-field-container">
          <div className="input-name">EUIN Declaration</div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Search"
              name="search"
              value={radioValue.value}
              style={{ flexDirection: "row" }}
              onChange={this.changeValue("radioValue")}
            >
              <div className="investor-radio-button">
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#005DAC" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">YES</div>
              </div>
              <div className="investor-radio-button">
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#005DAC" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">NO</div>
              </div>
            </RadioGroup>
          </FormControl>
        </div>
        {radioValue.value === "no" ? (
          <div className="input-margin">
            <IntegrationReactSelect
              suggestions={euinList.map((item) => ({
                label: item.abm_agent,
                value: item.abm_agent,
              }))}
              label="Fund"
              handleChange={this.changeEuin}
              value={euinNo.value}
              disabled={!euinList.length}
              placeholder="Select EUIN"
              inputRef={(ele) => (this.euinField = ele)}
              isError={euinNo.isError}
              errorMessage={euinNo.errorMessage}
            />
          </div>
        ) : (
          <div className="euin-text">
            I/We hereby confirm that the EUIN box has been intentionally left
            the blank by me/us as this is an 'execution-only' transaction
            without any interaction or advice by any personnel of the above
            distributor or notwithstanding the advice of in-appropriateness,if
            any provided by any personnel of the distributor and the distributor
            has not charged any advisory fees on this transaction
          </div>
        )}
        <div className="input-margin">
          <CustomizedSelect
            name="STP Frequency"
            placeholder="STP Frequency"
            disabled={!switchInScheme.value}
            inputRef={(ele) => (this.stpFrequencyField = ele)}
            handleChange={this.handleChangeStpFrequency}
            value={this.state.swpFrequency.value}
          >
            {stpDates.length > 0
              ? stpDates.map((item, index) => (
                  <MenuItem value={item.FrequencyID} key={index}>
                    {item.FrequencyDescription}
                  </MenuItem>
                ))
              : ""}
            {/* {
              <MenuItem value={switchInScheme.value !== "" ? "Monthly" : ""}>
                {switchInScheme.value !== "" ? "Monthly" : ""}
              </MenuItem>
            } */}
          </CustomizedSelect>
        </div>
        {this.state.swpFrequency.value === "Weekly" && (
          <div
            style={{
              fontSize: 15,
              color: "#194b7e",
              marginBottom: "10px",
            }}
          >
            <span style={{ color: "#005DAC" }}>Note:</span>
            STP Start Date should fall on Wednesday when opted for Weekly.
          </div>
        )}
        <div className="input-margin">
          <Input
            name={`No of Transfers (minimum:${this.state.minimumInstallments})`}
            value={transfers.value}
            type="number"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            onChange={this.handleChangeTransfers}
            onBlur={this.showError("transfers")}
            isShowError={transfers.isError}
            errorMessage={transfers.errorMessage}
          />
        </div>

        <div className="input-margin">
          <CustomizedSelect
            name="STP Date"
            inputRef={(ele) => (this.swpDateField = ele)}
            isError={sipDay.isError}
            placeholder="STP Date"
            value={
              this.state.sipDay.value
              // this.state.transfers.value !== "" && (e > 60 || e === 60)
              //   ? this.state.sipDay.value
              //   : ""
            }
            onBlur={this.showError("transfers")}
            handleChange={(event) => this.handleSwpDay(event)}
            errorMessage={sipDay.errorMessage}
          >
            {sipCycle.map((item, index) => (
              <MenuItem value={item.sip_cycleid} key={index}>
                {item.sip_cycleid}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>

        <div className="input-name">Time Period</div>
        <div className="input-margin">
          <Input
            name={
              "From " +
              (!!this.state.swpFrequency.value &&
              this.state.swpFrequency.value === "Weekly"
                ? " (Based on the selection of date, the next available Wednesday is)"
                : "")
            }
            value={sipStartDate.value}
            disabled={true}
            image={"/images/date_cal.svg"}
          />
        </div>
        <div className="input-margin">
          <Input
            name="To"
            disabled={true}
            value={sipEndDate.value}
            image={"/images/date_cal.svg"}
          />
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="STP Option"
            placeholder="STP Option"
            inputRef={(ele) => (this.swpField = ele)}
            isError={swpOption.isError}
            errorMessage={swpOption.errorMessage}
            value={swpOption.value}
            handleChange={this.handleSwpOptionChange}
            disabled
          >
            {swpOptions.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.Description}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        {swpOption.value.Description === "Fixed" ? (
          <Input
          name={`Transfer Amount per Installment (minimum amount: ${this.state.minAmount.value} INR)"`}
          onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            onChange={this.handleChangeTransferAmount}
            value={amount.value}
            type="number"
            onBlur={this.showError("amount")}
            isShowError={amount.isError}
            errorMessage={amount.errorMessage}
          />
        ) : (
          ""
        )}
        <div className="digital-form-button-next-div">
          <Signbutton buttontitle="Submit" onClick={this.submit} />
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
    } = authReducer;
    const { euinList, stpDetails = {}, transactionDetails } = transactions;
    return {
      fundList,
      token,
      userId,
      euinList,
      stpDetails,
      bankDetails,
      investorData,
      communicationDetails,
      transactionDetails,
    };
  },
  {
    validateSubBroker,
    getAssetClasses,
    getOtherSchemes,
    swpOptions,
    setStpDetails,
    CalcSIPEnddt,
    saveTransactionDetails,
    getMinimumAmount
  }
)(Stp);

export const calculateStpDates = (transfers, selectedDate) => {
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  const isSelectedDatePassed = new Date().setDate(selectedDate) < today;
  var startDate = isSelectedDatePassed
    ? new Date(addMonths(new Date().setDate(selectedDate), 1))
    : new Date(new Date().setDate(selectedDate));
  if (startDate < new Date(addDays(today, 5))) {
    startDate = new Date(addDays(today, 5));
  }
  while (true) {
    if (isWednesday(startDate)) {
      const endDate = addWeeks(startDate, transfers - 1);
      return {
        startDate: { value: format(startDate, "dd/MM/yyyy") },
        endDate: { value: format(endDate, "dd/MM/yyyy") },
      };
    }
    startDate = addDays(startDate, 1);
  }
};
